<i18n lang="yaml">
pt:
  welcomeMessage: 'O time {workspaceName} está feliz em te ver aqui! 🙌 '
  signIn:
    title: 'Entre na Área de Trabalho'
  signUp:
    title: 'Faça seu cadastro e confira nossas carreiras'

en:
  welcomeMessage: '{workspaceName} welcomes you! 🙌'
  signIn:
    title: 'Log into workspace'
  signUp:
    title: 'Sign up and check our careers'
</i18n>
<template>
  <AuthLogin
    :layout-attrs="{
      title: t('welcomeMessage', { workspaceName }),
    }"
    default-tab="signIn"
    :modules="['signIn', 'signUp', 'magicLink']"
    :module-attrs="{
      signIn: {
        title: t('signIn.title'),
      },
      signUp: {
        title: t('signUp.title'),
      },
    }"
  />
</template>

<script lang="ts">
import { mapGetters } from '~/assets/javascript/modules/vuex';
import AuthLogin from '~/components/auth/login';

export default defineComponent({
  name: 'Login',
  components: { AuthLogin },
  setup() {
    const { t } = useI18n();

    definePageMeta({
      middleware: ['auth-fetch-user', 'auth-redirect'],
      layout: 'public',
    });

    useAnalyticsPage('auth-tenant-login');

    return {
      t,
      ...mapGetters('workspace', ['workspaceName']),
    };
  },
});
</script>
